import styled from "styled-components";


export const Container = styled.div`
    height: 20px;
    width: 100%;
    background-color: #e0e0de;
    border-radius: 50px;
`

export const Filler = styled.div`
    height: 100%;
    background-color: #FF2E2E;
    border-radius: inherit;
    text-align: right;
`

export const Label = styled.span`
    padding: 5px;
    color: white;
    font-weight: bold;
`